import { Component, Input } from '@angular/core';
import { Globals } from '../../../../../globals';

/**
 * Generated class for the MenuCreateSelectTypePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-menu-create-partial-title',
  templateUrl: 'menu-create-partial-title.html',
})
export class MenuCreatePartialTitlePage {

  @Input() form;

  constructor(public globals: Globals,) {

  }

  ngOnInit() {
    
  }

}



// WEBPACK FOOTER //
// ./src/pages/menu/menu-create/menu-create-title/menu-create-partial-title/menu-create-partial-title.ts